import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ref, set } from "firebase/database";
import { setEditSupplier } from "../../redux/slices/supplier";
import { database } from "../../firebaseConfig";
import { setLoading } from "../../redux/slices/ui";
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import { Input } from "../ui/Field";

const ModalEditSupplier = () => {
  const dispatch = useDispatch();
  const selected = useSelector((state) => state.suppliers.edit);
  const suppliers = useSelector((state) => state.suppliers.list);

  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [commission, setCommission] = React.useState(0);

  React.useEffect(() => {
    if (selected) {
      setName(suppliers[selected].name);
      setPhone(suppliers[selected].phone);
      setEmail(suppliers[selected].email);
      setCommission(suppliers[selected].commission);
    }
  }, [selected]);

  const handleClose = () => dispatch(setEditSupplier(undefined));

  const handleSave = async () => {
    dispatch(setLoading(true));
    const data = { name, email, phone, commission: parseFloat(commission).toFixed(2) };
    await set(ref(database, `suppliers/${selected}`), data);
    dispatch(setLoading(false));
    handleClose();
  };

  const handlePromitheiaChange = (e) => {
    const value = e.target.value.replace(",", ".");
    if (!isNaN(value) && value >= 0 && value <= 100) setCommission(value);
  };

  return (
    <Modal
      open={!!selected}
      onClose={handleClose}
      title="Επεξεργασία προμηθευτή"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            Ακύρωση
          </Button>
          <Button onClick={handleSave}>Ενημέρωση</Button>
        </>
      }
    >
      <div className="space-y-3 py-1">
        <Input label="Επωνυμία" value={name} autoComplete="off" onChange={(e) => setName(e.target.value)} />
        <Input label="Τηλέφωνο" type="tel" value={phone} autoComplete="off" onChange={(e) => setPhone(e.target.value)} />
        <Input label="email" type="email" value={email} autoComplete="off" onChange={(e) => setEmail(e.target.value)} />
        <Input label="Προμήθεια %" inputMode="decimal" value={commission} autoComplete="off" onChange={handlePromitheiaChange} />
      </div>
    </Modal>
  );
};

export default ModalEditSupplier;
